import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useToast } from "../../../../context/ToastContext";
import httpService from "../../../../utils/request";

const languageSchema = z.object({
  name: z.string().min(1, "Tên ngôn ngữ là bắt buộc"),
  code: z.string().min(1, "Mã ngôn ngữ là bắt buộc"),
  description: z.string().optional(),
});

const CreateLanguageModal = ({ show, handleClose, handleCreate }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      code: "",
      description: "",
      status: true,
    },
    resolver: zodResolver(languageSchema),
  });
  const showToast = useToast();

  const onSubmit = async (data) => {
    try {
      try {
        const response = await httpService.post("/private/languages", data);
        handleCreate({ id: response.id, ...data });
        showToast("Thêm mói ngôn ngữ thành công", { type: "success" });
        reset();
      } catch (error) {
        showToast(error.response.data, {
          position: "top-right",
          autoClose: 3000,
          type: "error",
        });
      }
    } catch (error) {
      showToast("Có lỗi xảy ra", { type: "error" });
    }
  };

  const handleCloseModal = () => {
    reset();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleCloseModal}>
      <Modal.Header>
        <Modal.Title>Thêm mới ngôn ngữ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="languageName">
            <Form.Label>
              Tên ngôn ngữ <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              {...register("name")}
              isInvalid={!!errors.name}
            />
            {errors.name && (
              <Form.Control.Feedback type="invalid">
                {errors.name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group controlId="code" className="mt-1">
            <Form.Label>
              Mã ngôn ngữ <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              {...register("code")}
              isInvalid={!!errors.code}
            />
            {errors.code && (
              <Form.Control.Feedback type="invalid">
                {errors.code.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group controlId="languageDescription" className="mt-1">
            <Form.Label>Mô tả</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              {...register("description")}
              isInvalid={!!errors.description}
            />
            {errors.description && (
              <Form.Control.Feedback type="invalid">
                {errors.description.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Đóng
            </Button>
            <Button variant="primary" type="submit">
              Thêm mới
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLanguageModal;
